import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import {
  AutomaticPerminuteTariff,
  AutostartPerminuteTariff,
  HolidayTariffs,
} from './components';

export const Tariffs: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('nav.tariffs')}>
        <SettingsFrame separator>
          <AutostartPerminuteTariff />
          <AutomaticPerminuteTariff />
        </SettingsFrame>

        <SettingsFrame>
          <HolidayTariffs />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
